import React, { useEffect, useState } from 'react';
import { AdddrivingSchoolcategory, getSingleDrivingSchoolCategory, updateDrivingSchoolCategory } from '../../actions/homeAction';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

export default function AdddrivingSchoolCategory() {
  const dispatch = useDispatch();
  const [AddCategory, setAddCategory] = useState({
    category: '',
    categoryEn: '',
    active: '',
    priority: 0,
  });

  const { drivingUUID } = useParams();
  const dataEdit = Boolean(drivingUUID);

  useEffect(() => {
    if (dataEdit) {
      dispatch(getSingleDrivingSchoolCategory(drivingUUID));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const single = useSelector((state) => state.home.getSingleDrivingSchoolCat)?.response;

  useEffect(() => {
    if (single) {
      setAddCategory({
        category: single?.category,
        categoryEn: single?.categoryEn,
        active: single?.active,
        priority: single?.priority,
      });
    }
  }, [single]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAddCategory((user) => ({ ...user, [name]: value }));
  };

  const onSave = () => {
    if (!AddCategory.category || !AddCategory.categoryEn) {
      alert('Please enter the category name in both Arabic and English');
      return;
    }
    if (dataEdit) {
      dispatch(
        updateDrivingSchoolCategory({
          categoryId: single?.categoryId,
          category: AddCategory.category,
          categoryEn: AddCategory.categoryEn,
          priority: AddCategory.priority,
          active: AddCategory.active,
        })
      );
    } else {
      dispatch(AdddrivingSchoolcategory(AddCategory));
    }
  };

  return (
    <>
      <div className=''>
        <div className='col-md-6'>
          <div className='form-group row'>
            <div className='m-4'>
              <h1>{dataEdit ? 'Edit' : 'Add'} Driving School Category</h1>
            </div>
            <div className='col-sm-9'></div>
          </div>
        </div>

        <div className='card-body'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group row'>
                <label className='col-sm-3 col-form-label'>Category (Arabic)</label>
                <div className='col-sm-9'>
                  <input
                    type='text'
                    className='form-control'
                    name='category'
                    id='BusinessCategory'
                    placeholder='Category (Arabic)'
                    onChange={handleChange}
                    value={AddCategory.category}
                  />
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='form-group row'>
                <label className='col-sm-3 col-form-label'>Category (English)</label>
                <div className='col-sm-9'>
                  <input
                    type='text'
                    className='form-control'
                    name='categoryEn'
                    id='BusinessCategoryEn'
                    placeholder='Category (English)'
                    onChange={handleChange}
                    value={AddCategory.categoryEn}
                  />
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='form-group row'>
                <label className='col-sm-3 col-form-label'>Priority</label>
                <div className='col-sm-9'>
                  <input
                    type='number'
                    className='form-control'
                    name='priority'
                    id='Priority'
                    placeholder='Priority'
                    onChange={handleChange}
                    value={AddCategory.priority}
                  />
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='form-group row'>
                <label className='col-sm-3 col-form-label'>Status</label>
                <div className='col-sm-9'>
                  <select
                    name='active'
                    className='form-control'
                    value={AddCategory.active}
                    onChange={handleChange}>
                    <option value=''>Select Status</option>
                    <option value='true'>Active</option>
                    <option value='false'>Inactive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className='card-footer'>
            <div className='row float-right p-3'>
              <button onClick={onSave} className='btn btn-grd-disabled mr-2'>
                <i className='icofont icofont-save'></i> Save
              </button>
              <Link
                to={'/BusinessCategoryMaster/DrivingSchoolCategory'}
                className='btn btn-outline-dark'>
                {' '}Cancel{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
